import React, { Component, Fragment } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import { pointName, array, number, shouldUpdate } from "../../../../utils";

import styles from "./styles.scss";
import points from "../../../../services/points";

let count = 0;
const idPrefix = "occurrencesTable";

@CSSModules(styles, { allowMultiple: true })
class OccurrencesTable extends Component {
	constructor(props) {
		super(props);
		this.props.initTable(this.props.id, this.props.component);
	}
	roundNumber(num, scale) {
        if (isNaN(num))
            return "";
            
		if (!("" + num).includes("e")) {
			return +(Math.round(num + "e+" + scale) + "e-" + scale);
		} else {
			var arr = ("" + num).split("e");
			var sig = "";
			if (+arr[1] + scale > 0) {
				sig = "+";
			}
			return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
		}
	}
	convertRowToActualRow(lookups, setPoints) {
		if (!lookups || !setPoints) {
			return;
		}

		return lookups.map((lookup, i) => {
			return (
				<tr key={lookup.lookupRuleId || i}>
					<td>{lookup.lookupRuleId}</td>
					{setPoints.map((setPoint, s) => {
						return (
							<td key={s}>
								<div styleName="paramsCell">
									{this.roundNumber(lookup["param" + (s + 1)], 2) +
										(lookup["param" + (s + 1) + "Range"]
											? " - " + this.roundNumber(lookup["param" + (s + 1) + "Range"], 2)
											: "")}
								</div>
							</td>
						);
					})}
					<td>{lookup.results && lookup.results.length}</td>
					{	lookup.outputs &&
						lookup.outputs
						.filter(x => !!x)
						.map((output, o) => {
							return (
								<td key={o}>
									<div>
										<b>Name: </b>
										<span>{pointName.formatDescription(output)}</span>
									</div>
									<div>
										<b>Action: </b>
										<span>{output.actionName}</span>
									</div>
									<div>
										<b>Value: </b>
										<span>
											{isNaN(output.value) ? output.value : number.parseNumber(output.value)}
										</span>
									</div>
								</td>
							);
						})}
				</tr>
			);
		});
	}

	render() {
		if (!this.props.hasTable) {
			return <div />;
		}
		const { tableRows, setPoints, lookups } = this.props;

		return (
			<div styleName="component-wrapper">
				<div styleName="component-title">{this.props.component.chartTitle || "Learned Rule Outcomes"}</div>
				<table styleName="occurences-table">
					<thead>
						<tr>
							<th styleName="table-header">Row</th>
							{tableRows &&
								tableRows.map((row, i) => {
									return (
										<th key={i}>
											{pointName.formatName(
												setPoints.find(x => x.paramColNumber.some(d => d === row.number)).point
													.pointName
											)}
										</th>
									);
								})}
							<th styleName="table-header">Count</th>
							{array.fill(this.props.maxOutputCount, x => (
								<th key={"o" + x} styleName="table-header">
									Output {x + 1}
								</th>
							))}
						</tr>
					</thead>
					<tbody>{this.convertRowToActualRow(lookups, setPoints)}</tbody>
				</table>
			</div>
		);
	}

	setup() {
		this.props.loadData(
			this.props.id,
			this.props.component,
			this.props.timePeriod,
			this.props.ruleInstance.ruleInstanceId,
			this.props.onLoadComplete
		);
	}

	componentDidMount() {
		this.setup();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.tableData != this.props.tableData) {
			return true;
		} else if (prevProps.component != this.props.component || prevProps.timePeriod != this.props.timePeriod) {
			this.setup();
			return false;
		} else {
			return false;
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
	}
}

const bindAction = dispatch => {
	return {
		loadData: (id, component, timePeriod, ruleInstanceId, onLoadComplete) =>
			dispatch(actions.loadData(id, component, timePeriod, ruleInstanceId, onLoadComplete)),
		initTable: (id, component) => dispatch(actions.initTable(id, component))
	};
};

const mapStateToProps = (state, ownProps) => {
	const table = state.learnedtable.instances[ownProps.id];
	return {
		...table,
		hasTable: !!table
	};
};

//do this to merge classes
export default class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			wrapped: null
		};
		this.id = idPrefix + count;
		count++;
	}

	componentWillMount() {
		this.setState({
			wrapped: connect(
				mapStateToProps,
				bindAction
			)(OccurrencesTable)
		});
	}

	render() {
		const Elem = this.state.wrapped;
		return <Elem {...this.props} id={this.id} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Tables/LearnedRuleTable/LearnedRuleTable.js